import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pr-questions',
    templateUrl: './pr-questions.component.html',
    styleUrls: ['./pr-questions.component.scss'],
    standalone: false
})
export class PrQuestionsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
